import React from 'react'
import style from './articles.style'

const Bitrix24 = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Создание вебхуков в Bitrix24</h2>
      <p>Для интеграции ROMI center с Bitrix24 на стороне последней должны быть созданы 2 вебхука</p>
      <ol>
        <li>Входящий вебхук</li>
        <li>Исходящий вебхук</li>
      </ol>
      
      <p>Добавьте вебхуки вледующим способом:</p>
      <ol>
        <li>
          Перейдите в раздел "Вебхуки" и нажмите на кнопку "Добавить вебхук"
          <figure className={classes.helpArticleFigure}>
            <img src="/images/bitrix24hooks1.png" alt="true" />
            <figcaption>Вебкухи</figcaption>
          </figure>
        </li>
        <li>
          Добавьте Исходящий вебхук. Заполните адрес обработчика, вставив нашу ссылку <b>https://romi.center/api/bitrix24</b>, а также произвольное название вебхука.
          <br/>В типе события отметьте "Обновление сделки (ONCRMDEALUPDATE)".
          <br/>Нажмите "Сохранить"
          <figure className={classes.helpArticleFigure}>
            <img src="/images/bitrix24hooks2.png" alt="true" />
            <figcaption>Исходящий вебкух</figcaption>
          </figure>
        </li>
        <li>
          Заполните произвольное название вебхука, а также отметьте право доступа к "CRM".
          <br/>Нажмите "Сохранить"
          <figure className={classes.helpArticleFigure}>
            <img src="/images/bitrix24hooks3.png" alt="true" />
            <figcaption>Входящий вебкух</figcaption>
          </figure>
        </li>
      </ol>

      <h2>Подлючение Bitrix24 к аккаунту ROMI center</h2>
      <ol>
        <li>
          Скопируйте код авторизации и вставьте в соответствующее поле на форме подключения Bitrix24 в личном кабинете ROMI center
          <figure className={classes.helpArticleFigure}>
            <img src="/images/bitrix24hooks4.png" alt="true" />
            <figcaption>Код авторизации</figcaption>
          </figure>
        </li>
        <li>
          Скопируйте URL для вызова REST и вставьте в соответствующее поле на форме подключения Bitrix24 в личном кабинете ROMI center
          <figure className={classes.helpArticleFigure}>
            <img src="/images/bitrix24hooks5.png" alt="true" />
            <figcaption>URL для вызова REST</figcaption>
          </figure>
        </li>
      </ol>
    </article>
  )
}

export default style(Bitrix24)
